// import node module libraries
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ChartState {
  xAxis: string;
  yAxis: string;
}

const initialState: ChartState = {
  xAxis: "",
  yAxis: "",
};

const chartSlice = createSlice({
  name: "chart",
  initialState,
  reducers: {
    setXAxis: (state, action: PayloadAction<string>) => {
      state.xAxis = action.payload;
    },
    setYAxis: (state, action: PayloadAction<string>) => {
      state.yAxis = action.payload;
    },
  },
});

export const { setXAxis, setYAxis } = chartSlice.actions;

export default chartSlice.reducer;
